import React, { useLayoutEffect } from "react";
import { FiveStarLifeInsurranceCompanyLogo, TermLife121Brochure } from "../../../../../assets";
import BrochureRenderer from "../../../../shared/brochureRenderer/BrochureRenderer";
import VEBTermLifeImage from "../../../../../assets/VEBPlanImages/VEBTeamLifeImage.avif";
import "./termlife.scss";

const TeamLifeCoverage: React.FC = (): JSX.Element => {
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	});
	return (
		<div className="accident-indemnity-plan-main-container">
			<div className="main-landing-container">
				<div className="left-section">
					<h3 className="main-benefits-title">Team Life To Age 121</h3>
					<div className="powered-by-logo-container">
						<span>Powered By</span>
						<img src={FiveStarLifeInsurranceCompanyLogo} alt="" />
					</div>
					<div className="plan-description">
						<span>
							When you or a loved one is diagnosed with a significant age-related condition, the financial
							strain can become daunting. While primary insurance may assist with some of the related
							expenses, individuals often encounter difficulties related to time away from work and costs
							that may not be covered by other insurance policies.
						</span>

						<h3>Stay focused on getting well</h3>
						<span>
							A 5 Star Team Life To Age policy offers an additional layer of financial security during
							challenging times related to eye vision issues. It provides benefits that can be utilized to
							manage expenses and safeguard your savings, allowing you to concentrate on improving your
							vision health.
						</span>
					</div>
				</div>
				<div className="right-section">
					<img src={VEBTermLifeImage} alt="VEBTermLifeImage" />
				</div>
			</div>
			<h3 className="sub-heading-title">Plan Brochure</h3>

			<div className="brochure-renderer-container" style={{ overflow: "hidden" }}>
				<BrochureRenderer brochure={TermLife121Brochure} />
			</div>
		</div>
	);
};

export default TeamLifeCoverage;
